import { Component } from '@angular/core';

@Component({
  selector: 'external-access-layout',
  templateUrl: './external-access-layout.component.html',
  styleUrl: './external-access-layout.component.scss',
  standalone: false,
})
export class ExternalAccessLayoutComponent {}
